import React, {Component} from "react";
import {injectIntl} from "react-intl";
import {connect} from "react-redux";
import {Col, Modal, Row} from "antd";
import BoxFooter from "../BoxFooter";
import './FleetbackIntervention.css'
import FleetbackPayment from "./FleetbackPayment";
import FleetbackHistory from "./FleetbackHistory";
import Constants from "../../../services/Constants";

class FleetbackIntervention extends Component {

  constructor(props){
    super(props)
    this.state = {
      visible:false
    }
  }

  onGotoClick = (link) => {
    window.open(link);
  }

  onPreviewClick = () => {
    this.setState({visible:true})
  }

  onSendClick = (intervention) => {
    this.props.sendIntervention({fleetbackId:intervention.fleetbackId})
  }

  render() {
    const {intl:{formatMessage}, fleetbackIntervention, intervention} = this.props;
    const displaySendButton = intervention.origin === Constants.ORIGIN_MOBILE.value || fleetbackIntervention.customerNotification === true;
    return (<React.Fragment>
        <div className="fleetback-panel-body pb-5">
          <Row gutter={32}>
            <Col span={12} className={"fleetback-panel-left"}>
              <FleetbackPayment paymentSummary={fleetbackIntervention.paymentSummary}/>
            </Col>
            <Col span={12} className={"fleetback-panel-right"}>
              <FleetbackHistory fleetbackIntervention={fleetbackIntervention}/>
            </Col>
          </Row>
        </div>
        <BoxFooter>
          {fleetbackIntervention.gotoLink && <button type="primary" onClick={(e)=>this.onGotoClick(fleetbackIntervention.gotoLink)}  className={`btn btn-sm btn-primary`}>
            {formatMessage({id: 'fleetback.deeplink.goto'})}
          </button>}
          <button type="primary" onClick={(e)=>this.onPreviewClick(fleetbackIntervention)} className={`btn btn-sm btn-primary`}>
            {formatMessage({id: 'fleetback.deeplink.preview'})}
          </button>
          {displaySendButton && <button type="primary" onClick={(e)=>this.onSendClick(fleetbackIntervention)} className={`btn btn-sm btn-primary`}>
            {formatMessage({id: 'fleetback.deeplink.send'})}
          </button>}
        </BoxFooter>
        <Modal width={1000} height={1000} bodyStyle={{width:'1000px', height:'1000px', padding:'0px'}} visible={this.state.visible} onCancel={()=>this.setState({visible:false})} footer={null} closable={false} destroyOnClose={true} maskClosable={true}>
          <iframe className="fleetback-preview-frame" src={fleetbackIntervention.previewLink} title={"fleetback preview iframe"}></iframe>
        </Modal>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  intervention: state.fetchIntervention && state.fetchIntervention.intervention,
})

const mapDispatchToProps = dispatch => ({
  sendIntervention:(params) => dispatch({type:"SAVE.SEND_INTERVENTION.REQUEST", ...params}),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(FleetbackIntervention))
